// import { Breadcrumb } from "@gull";
// import React, { Component } from "react";
// import { Card, Col, Row } from "react-bootstrap";
// import { Helmet } from "react-helmet";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { Formik, Field, Form, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import "./payment.css";
// // import bankService from "app/services/bankService";
// import paymentService from "app/services/paymentService";
// import moment from "moment";
// import { NotificationManager } from "react-notifications";
// import {
//   RenderDateInput,
//   RenderSelectInput,
//   RenderTextInput,
// } from "app/common/renderInput";
// import bankService from "app/services/DistributorServices/bankService";

// const requisitionSchema = Yup.object().shape({
//   amount: Yup.number()
//     .required("Please enter Amount")
//     .min(1, "Amount should be greater than 0"),
//   bankId: Yup.string().required("Please enter Payment Through"),
//   transferMethod: Yup.string().required("Please select Payment Type"),
//   referenceNo: Yup.string()
//     .min(6, "Reference must be at least 6 characters")
//     .required("Please enter Referance Number"),
//   transactionDetails: Yup.string().optional(),
//   requestDate: Yup.string().required("Please enter Request Date"),
// });
// const { allGetBankList, getBankList, getRequisitionBankList } = bankService;
// const { addRedHandler } = paymentService;
// class AddReq extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       requestDate: "",
//       amount: "",
//       bankId: "",
//       transactionDetails: "",
//       transferMethod: "NEFT",
//       //  creditrans: false,
//       bankCharges: 0,
//       referenceNo: "",
//       bankList: [],
//       paymentTypeList: [
//         { value: "NEFT", label: "NEFT" },
//         { value: "UPI", label: "UPI" },
//         { value: "RTGS", label: "RTGS" },
//         { value: "ONLINE", label: "ONLINE" },
//       ],
//     };
//   }

//   loadBankLists = async () => {
//     const response = await getRequisitionBankList();
//     const bankData = response.data;
//     const bankList = bankData.map((x, i) => {
//       return {
//         value: x.id,
//         label: x.bankName + " - " + x.accountNumber,
//       };
//     });
//     // debugger
//     this.setState({
//       bankList,
//     });
//   };

//   async componentDidMount() {
//     await this.loadBankLists();
//   }

//   requisitionHandler = async (values, { resetForm }) => {
//     // console.log(values);
//     // debugger
//     const res = await addRedHandler(values);
//     {
//       res
//         ? NotificationManager.success("Requisition done successfully")
//         : NotificationManager.danger("Requisition Failed");
//     }

//     document
//       .querySelectorAll("input[type=checkbox]")
//       .forEach((el) => (el.checked = false));
//     resetForm({ values: "" });
//   };

//   handlChangeDate = (date) => {
//     this.setState({
//       requestDate: moment(date).format("DD-MM-YYYY"),
//     });
//   };

//   render() {
//     return (
//       <div>
//         <Helmet>
//           <title>Add Requisition</title>
//         </Helmet>
//         <Breadcrumb routeSegments={[{ name: "Add Requisition" }]}></Breadcrumb>
//         <div>
//           <Card>
//             <Card.Body>
//               <Formik
//                 initialValues={this.state}
//                 validationSchema={requisitionSchema}
//                 onSubmit={this.requisitionHandler}
//               >
//                 {({
//                   values,
//                   errors,
//                   touched,
//                   handleChange,
//                   handleBlur,
//                   handleSubmit,
//                   isSubmitting,
//                 }) => (
//                   <form onSubmit={handleSubmit}>
//                     {/* <div>
//                         <div className="col-md-12">
//                           {Object.values(errors).map(msg => (
//                             <>
//                               {msg}
//                               <br />
//                             </>
//                           ))}
//                         </div>
//                       </div> */}

//                     <Row className="mb-3 mt-3">
//                       <Col>
//                         <RenderTextInput
//                           type="text"
//                           name="amount"
//                           display="Amount"
//                           placeholder="Amount"
//                           value={values.amount}
//                           error={errors.amount}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.amount}
//                           required
//                         ></RenderTextInput>

//                         {/* <div className="form-group">
//                           <label>Amount</label>
//                           <input
//                             type="number"
//                             className="form-control"
//                             placeholder="Enter your amount"
//                             name="amount"
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             value={values.amount}
//                             errors={errors.amount}
//                             touched={touched.amount}
//                           />
//                           {errors.amount && touched.amount && (
//                             <div className="text-danger mb-1">
//                               {errors.amount}
//                             </div>
//                           )}
//                         </div> */}
//                       </Col>
//                       <Col>
//                         {/* <RenderSelectInput
//                               name="bankId"
//                               display="Payment Through"
//                               value={values.bankId}
//                               error={errors.bankId}
//                               onChange={handleChange}
//                               onBlur={handleBlur}
//                               touched={touched.bankId}
//                               items={this.state.bankList}
//                             ></RenderSelectInput> */}

//                         <RenderSelectInput
//                           name="bankId"
//                           display="Payment Through"
//                           placeholder="Payment Through"
//                           value={values.bankId}
//                           error={errors.bankId}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.bankId}
//                           items={this.state.bankList}
//                           required
//                         ></RenderSelectInput>

//                         {/* <div className="form-group">
//                           <label> Payment Through</label>
//                           <select
//                             className="form-control custom-select inputReq"
//                             name="bankId"
//                             value={values.bankId}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                           >
//                             <option>Please select bank </option>
//                             {this.state.bankList.map((item, i) => (
//                               <>
//                                 <option key={i} value={item.id}>
//                                   {item.bankName} - {item.accountNumber}
//                                 </option>
//                               </>
//                             ))}
//                           </select>
//                           {errors.bankId && touched.bankId ? (
//                             <div className="text-danger mb-1">
//                               {errors.bankId}
//                             </div>
//                           ) : (
//                             ""
//                           )}
//                         </div> */}
//                       </Col>
//                       <Col>
//                         <RenderSelectInput
//                           name="transferMethod"
//                           display="Payment Type"
//                           placeholder="Payment Through"
//                           value={values.transferMethod}
//                           error={errors.transferMethod}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.transferMethod}
//                           items={this.state.paymentTypeList}
//                           required
//                         ></RenderSelectInput>

//                         {/* <div className="form-group">
//                           <label>Payment Type</label>
//                           <select
//                             name="transferMethod"
//                             className="form-control custom-select inputReq"
//                             value={values.transferMethod}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             errors={errors.transferMethod}
//                           >
//                             <option defaultValue="NEFT">NEFT</option>
//                             <option value="UPI">UPI</option>
//                             <option value="RTGS">RTGS</option>
//                             <option value="ONLINE">Online</option>
//                           </select>
//                           {touched.transferMethod && errors.transferMethod && (
//                             <div className="text-danger mb-1">
//                               {errors.transferMethod}
//                             </div>
//                           )}
//                         </div> */}
//                       </Col>
//                     </Row>
//                     <Row className="mb-4">
//                       <Col>
//                         <RenderTextInput
//                           type="text"
//                           name="referenceNo"
//                           display="Reference No"
//                           placeholder="Reference No"
//                           value={values.referenceNo}
//                           error={errors.referenceNo}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.referenceNo}
//                           required
//                         ></RenderTextInput>
//                       </Col>
//                       <Col>
//                         <RenderDateInput
//                           type="date"
//                           name="requestDate"
//                           display="Request Date"
//                           onBlur={handleBlur}
//                           value={values.requestDate}
//                           onChange={handleChange}
//                           touched={touched.requestDate}
//                           error={errors.requestDate}
//                           required
//                         ></RenderDateInput>

//                         {/* <label> Request Date</label>
//                         <br />
//                         <input
//                           type="date"
//                           name="requestDate"
//                           onBlur={handleBlur}
//                           value={values.requestDate}
//                           onChange={handleChange}
//                           touched={touched.requestDate}
//                           errors={errors.requestDate}
//                           className="form-control"
//                         />

//                         {touched.requestDate && errors.requestDate && (
//                           <div className="text-danger mb-1">
//                             {errors.requestDate}
//                           </div>
//                         )} */}
//                       </Col>

//                       <Col>
//                         <RenderTextInput
//                           type="text"
//                           name="transactionDetails"
//                           display="Remarks (if any)"
//                           placeholder="transactionDetails"
//                           value={values.transactionDetails}
//                           error={errors.transactionDetails}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.transactionDetails}
//                           required
//                         ></RenderTextInput>

//                         {/* <label>Remarks (if any)</label>
//                         <textarea
//                           className="form-control inputReq"
//                           name="transactionDetails"
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           value={values.transactionDetails}
//                           touched={touched.transactionDetails}
//                           errors={errors.transactionDetails}
//                           rows="1"
//                         ></textarea>
//                         {touched.transactionDetails &&
//                           errors.transactionDetails && (
//                             <div className="text-danger mb-1">
//                               {errors.transactionDetails}
//                             </div>
//                           )} */}
//                       </Col>
//                     </Row>

//                     <Row>
//                       <Col className="mt-2">
//                         <button type="submit" className="btn btn-primary">
//                           Submit Requisition
//                         </button>
//                       </Col>
//                     </Row>
//                   </form>
//                 )}
//               </Formik>
//             </Card.Body>
//           </Card>
//         </div>
//       </div>
//     );
//   }
// }

// export default AddReq;
import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./payment.css";
import { addRedHandler } from "app/services/paymentService";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextInput,
} from "app/common/renderInput";
import { getRequisitionBankList } from "app/services/bankService";
import { Breadcrumb } from "@gull";

const requisitionSchema = Yup.object().shape({
  amount: Yup.number()
    .required("Please enter Amount")
    .min(1, "Amount should be greater than 0"),
  bankId: Yup.string().required("Please enter Payment Through"),
  transferMethod: Yup.string().required("Please select Payment Type"),
  referenceNo: Yup.string()
    .min(6, "Reference must be at least 6 characters")
    .required("Please enter Reference Number"),
  transactionDetails: Yup.string().optional(),
  requestDate: Yup.string().required("Please enter Request Date"),
});

const AddReq = () => {
  const [requestDate, setRequestDate] = useState("");
  const [amount, setAmount] = useState("");
  const [bankId, setBankId] = useState("");
  const [transactionDetails, setTransactionDetails] = useState("");
  const [transferMethod, setTransferMethod] = useState("NEFT");
  const [bankCharges, setBankCharges] = useState(0);
  const [referenceNo, setReferenceNo] = useState("");
  const [bankList, setBankList] = useState([]);
  const [paymentTypeList] = useState([
    { value: "NEFT", label: "NEFT" },
    { value: "UPI", label: "UPI" },
    { value: "RTGS", label: "RTGS" },
    { value: "ONLINE", label: "ONLINE" },
  ]);

  useEffect(() => {
    loadBankLists();
  }, []);

  const loadBankLists = async () => {
    const response = await getRequisitionBankList();
    const bankData = response.data;
    const bankList = bankData.map((x, i) => {
      return {
        value: x.id,
        label: x.bankName + " - " + x.accountNumber,
      };
    });
    setBankList(bankList);
  };

  const requisitionHandler = async (values, { resetForm }) => {
    const res = await addRedHandler(values);
    if (res) {
      NotificationManager.success("Requisition done successfully");
    } else {
      NotificationManager.danger("Requisition Failed");
    }

    document
      .querySelectorAll("input[type=checkbox]")
      .forEach((el) => (el.checked = false));
    resetForm({ values: "" });
  };

  const handlChangeDate = (date) => {
    setRequestDate(moment(date).format("DD-MM-YYYY"));
  };

  return (
    <div>
      <Helmet>
        <title>Add Requisition</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Add Requisition" }]}></Breadcrumb>
      <div>
        <Card>
          <Card.Body>
            <Formik
              initialValues={{
                requestDate,
                amount,
                bankId,
                transactionDetails,
                transferMethod,
                bankCharges,
                referenceNo,
              }}
              validationSchema={requisitionSchema}
              onSubmit={requisitionHandler}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3 mt-3">
                    <Col>
                      <RenderTextInput
                        type="text"
                        name="amount"
                        display="Amount"
                        placeholder="Amount"
                        value={values.amount}
                        error={errors.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.amount}
                        required
                      ></RenderTextInput>
                    </Col>
                    <Col>
                      <RenderSelectInput
                        name="bankId"
                        display="Payment Through"
                        placeholder="Payment Through"
                        value={values.bankId}
                        error={errors.bankId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.bankId}
                        items={bankList}
                        required
                      ></RenderSelectInput>
                    </Col>
                    <Col>
                      <RenderSelectInput
                        name="transferMethod"
                        display="Payment Type"
                        placeholder="Payment Through"
                        value={values.transferMethod}
                        error={errors.transferMethod}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.transferMethod}
                        items={paymentTypeList}
                        required
                      ></RenderSelectInput>
                    </Col>
                  </Row>
                  <Row className="mb-4">
                    <Col>
                      <RenderTextInput
                        type="text"
                        name="referenceNo"
                        display="Reference No"
                        placeholder="Reference No"
                        value={values.referenceNo}
                        error={errors.referenceNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.referenceNo}
                        required
                      ></RenderTextInput>
                    </Col>
                    <Col>
                      <RenderDateInput
                        type="date"
                        name="requestDate"
                        display="Request Date"
                        onBlur={handleBlur}
                        value={values.requestDate}
                        onChange={handleChange}
                        touched={touched.requestDate}
                        error={errors.requestDate}
                        required
                      ></RenderDateInput>
                    </Col>
                    <Col>
                      <RenderTextInput
                        type="text"
                        name="transactionDetails"
                        display="Remarks (if any)"
                        placeholder="transactionDetails"
                        value={values.transactionDetails}
                        error={errors.transactionDetails}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.transactionDetails}
                        required
                      ></RenderTextInput>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mt-2">
                      <button type="submit" className="btn btn-primary">
                        Submit Requisition
                      </button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default AddReq;
